export const RejectErrorHandleFields = {
  rejectComment: {
    name: 'rejectComment',
    message: 'Please provide reject comment and ensure the length is not more than 200',
  }
};
